<template>
  <div class="trainCont">
    <div class="topBtnCont">
      <div class="leftCont">
        <el-button size="small" type="primary" style="margin-right: 10px" @click="addOrEdit('add')">添加专业</el-button>
        <el-button size="small" type="primary" style="margin-right: 10px" @click="importVisible = true">Excel批量添加
        </el-button>
        <el-button size="small" @click="downloadTemplate">下载Excel示例</el-button>
      </div>
      <div class="rightCont">
        <el-input size="small" placeholder="请输入专业名" v-model="inputSearch" class="input-with-select"></el-input>
        <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      </div>
    </div>
    <div class="middleCont">
      <div class="tableCont">
        <el-table
          v-loading="loading"
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :max-height="tableHeight"
          :header-cell-style="headRowClass"
          :cell-style="rowClass"
        >
          <el-table-column
            label="大类"
            prop="faculty_name"
            width="200"
            align="center"
          />
          <el-table-column
            label="专业"
            prop="major_name"
            align="center"
          />
          <el-table-column
            label="学习阶段"
            prop="major_level"
            width="150"
            align="center"
          />
          <el-table-column
            label="年级"
            prop="grade_name"
            width="150"
            align="center"
          />
          <el-table-column
            label="培养方案"
            prop="pub_status"
            width="150"
            align="center"
          />
          <el-table-column
            label="更新时间"
            :formatter="formatterDate"
            prop="updated_at"
            align="center"
          />
          <el-table-column
            label="更新人"
            prop="creator_name"
            align="center"
          />
          <el-table-column prop="operate" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="toTrainPlain(scope.row)">培养计划</el-button>
              <el-button type="text" size="medium" @click="addOrEdit('edit',scope.row)">编辑</el-button>
              <el-button type="text" size="medium" @click="deleteRelation(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="添加/编辑" :visible.sync="addVisible" width="36%">
      <div class="dialog-form">
        <el-form
          ref="editRuleForm"
          :model="form1"
          :rules="rules"
          size="small"
          label-suffix=":"
          label-width="80px"
        >
          <el-form-item label="分类" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入分类名称"
              v-model="form1.faculty"
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="专业" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入专业名称"
              v-model="form1.major"
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="学习阶段" prop="name1">
            <el-select v-model="form1.level" placeholder="请选择学习阶段" style="width: 70%">
              <el-option
                v-for="(item,index) in leveData"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年级" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入年级"
              v-model="form1.grade"
              style="width: 80%"
            ></el-input>
            <span style="margin-left: 8px">例:2021级</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click.native="addOrEditOkLodash"
                   style="margin-right: 8px">确 定</el-button>
        <el-button size="medium" @click="addVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量添加"
      :visible.sync="importVisible"
      width="35%"
      height="350px"
    >
      <div class="upload-box">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="/api/relation/import-relation"
          :on-error="handleError"
          :on-success="handleSuccess"
          :file-list="fileList"
          :auto-upload="false"
          :multiple="false"
          :limit="1"
          :headers="headerData"
        >
          <el-input
            placeholder="请选择整理好的Excel"
            :disabled="true"
            style="width: 300px"
            size="medium"
          />
          <el-button size="medium" type="primary">选择文件</el-button>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="submitUpload" style="margin-right: 8px">确 定</el-button>
        <el-button size="medium" @click="importVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations} from "vuex";
import moment from "moment";
import trainMangeApi from '../../../api/trainMange'
import getCookie from "../../../utils/cookie";
import {debounce} from 'lodash'

export default {
  name: 'TrainProgram',
  components: {},
  computed: {},
  data() {
    return {
      loading: false,
      pageData: {
        page: 1,
        total: 1,
        search: "", // 搜索
      }, //分页
      tableData: [], //表格
      addVisible: false,
      form1: {
        faculty: '',
        major: '',
        level: '',
        grade: '',
      },
      rules: {
        faculty: [
          {required: true, message: "请输入分类名称", trigger: "blur"},
        ], major: [
          {required: true, message: "请输入专业名称", trigger: "blur"},
        ],
        level: [
          {required: true, message: "请选择学习阶段", trigger: "blur"},
        ],
        grade: [
          {required: true, message: "请选择年级", trigger: "blur"},
        ],
      },
      leveData: {
        0: '本科生',
        1: '研究生',
      },
      importVisible: false,
      fileList: [],
      headerData: {
        token: getCookie('_token'),
      },
      tableHeight: '650',
      inputSearch: ''
    }
  },
  mounted() {
    this.getRelationList()
    this.$nextTick(function () {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      let self = this;

      window.onresize = function () {
        self.tableHeight = window.innerHeight - self.$refs.table.$el.offsetTop - 80
      }
    })
  },
  methods: {
    ...mapMutations('trainMange', ['saveFacultyData']),
    formatterDate(row) {
      return moment(parseInt(row.updated_at) * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    getRelationList(params) {
      trainMangeApi.getRelationList(params).then(res => {
        if (res && res.code === 10000) {
          this.tableData = res.data
        } else {
          this.$message({message: res.message, type: "error"})
        }
      })
    },
    addOrEdit(type, data) {
      this.type = type
      if (type === 'add') {
        this.form1 = {
          faculty: '',
          major: '',
          level: '',
          grade: '',
        }
      } else if (type === 'edit') {
        this.form1 = {
          id: data.id,
          faculty: data['faculty_name'],
          major: data['major_name'],
          level: data['major_level'],
          grade: data['grade_name'],
        }
      }
      this.addVisible = true
    },
    addOrEditOkLodash:
      debounce(function (){
        this.addOrEditOk()
      }, 500),
    addOrEditOk() {
      if (this.type === 'add') {
        trainMangeApi.addRelation(this.form1).then(res => {
          if (res && res.code === 10000) {
            this.$message({message: '添加成功', type: "success"})
            this.getRelationList()
            this.addVisible = false
          } else {
            this.$message({message: res.message, type: "error"})
          }
        })
      } else if (this.type === 'edit') {
        trainMangeApi.updateRelation(this.form1).then(res => {
          if (res && res.code === 10000) {
            this.$message({message: '更新成功', type: "success"})
            this.getRelationList()
            this.addVisible = false
          } else {
            this.$message({message: res.message, type: "error"})
          }
        })
      }
    },
    deleteRelation(data) {
      this.$msgbox({
        // title: '删除课程分类',
        message: `您选择的是${data.faculty_name}分类下${data.major_name}${data.grade_name}${data.major_level},请问确认要删除吗?`,
        confirmButtonText: '删除',
        showCancelButton: true,
        customClass: 'delete-msgbox',
        iconClass: 'el-icon-info',
      }).then(() => {
        trainMangeApi.deleteRelation({id: data.id}).then(res => {
          if (res && res.code === 10000) {
            this.$message({message: '删除成功', type: "success"})
            this.getRelationList()
          } else {
            this.$message({message: res.message, type: "error"})
          }
        })
      })
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleError() {
      this.$message.error("上传失败");
    },
    handleSuccess(res) {
      if (res.code === 10000) {
        this.$message({message: '批量添加成功', type: "success"})
        this.getRelationList()
        this.importVisible = false
      } else {
        this.$message({message: res.message, type: "error"})
      }
      this.$emit('next')
    },
    downloadTemplate() {
      window.location.href = '/api/relation/download'
    },
    toTrainPlain(data) {
      this.$router.push('trainPlain')
      this.saveFacultyData(data)
    },
    headRowClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return "background:rgba(215,215,215,0.6)"
      }
    },
    rowClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex % 2 === 0) {
        return "background:rgb(242,242,242,0.5)"
      }
    },
    searchList() {
      this.getRelationList({name: this.inputSearch})
    }
  },
}
</script>

<style lang="less" scoped>

.trainCont {
  height: 100%;
  padding: 20px;
  box-sizing: border-box;

  .topBtnCont {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    .leftCont {

    }

    .rightCont {
      display: flex;
    }
  }

  .middleCont {
    .tableCont {
      margin-bottom: 15px;
    }

    .paginationCont {
      float: right;
    }
  }
}

/deep/ .el-dialog {
  .upload-box {
    display: flex;
    //align-items: center;
    justify-content: center;
    padding-left: 30px;
  }

  .el-dialog__footer {
    text-align: center;
  }
}

</style>
